import { defineStore } from "pinia";

interface AttendeeState {
  bookMeetingFirstName: string;
  bookMeetingLastName: string;
  bookMeetingEmail: string;
  bookMeetingNotes: string;
  bookMeetingTitle: string;
  bookMeetingCompany: string;
  bookMeetingLinkedinUrl: string;
  bookMeetingPhoneNumber: string;
  bookMeetingSmsOptIn: boolean;
}

export const useAttendeeStore = defineStore("attendee", {
  state: (): AttendeeState => ({
    bookMeetingFirstName: "",
    bookMeetingLastName: "",
    bookMeetingEmail: "",
    bookMeetingNotes: "",
    bookMeetingTitle: "",
    bookMeetingCompany: "",
    bookMeetingLinkedinUrl: "",
    bookMeetingPhoneNumber: "",
    bookMeetingSmsOptIn: false,
  }),
  actions: {
    setBookMeetingFirstName(firstName: string) {
      this.bookMeetingFirstName = firstName;
    },
    setBookMeetingLastName(lastName: string) {
      this.bookMeetingLastName = lastName;
    },
    setBookMeetingEmail(email: string) {
      this.bookMeetingEmail = email;
    },
    setBookMeetingNotes(notes: string) {
      this.bookMeetingNotes = notes;
    },
    setBookMeetingTitle(title: string) {
      this.bookMeetingTitle = title;
    },
    setBookMeetingCompany(company: string) {
      this.bookMeetingCompany = company;
    },
    setBookMeetingLinkedinUrl(linkedinUrl: string) {
      this.bookMeetingLinkedinUrl = linkedinUrl;
    },
    setBookMeetingPhoneNumber(phoneNumber: string) {
      this.bookMeetingPhoneNumber = phoneNumber;
    },
    setBookMeetingSmsOptIn(smsOptIn: boolean) {
      this.bookMeetingSmsOptIn = smsOptIn;
    },
    clearStore() {
      this.bookMeetingFirstName = "";
      this.bookMeetingLastName = "";
      this.bookMeetingEmail = "";
      this.bookMeetingNotes = "";
      this.bookMeetingTitle = "";
      this.bookMeetingCompany = "";
      this.bookMeetingLinkedinUrl = "";
      this.bookMeetingPhoneNumber = "";
      this.bookMeetingSmsOptIn = false;
    },
  },
  // Persist to sessionStorage so attendee details are scoped to the current
  // tab/session. This keeps details on a page refresh of the same booking, but
  // a new tab starts fresh so the same expert can be booked again (different
  // slot, or same slot with different attendee details) without carrying over
  // previously entered information.
  persist: {
    storage: sessionStorage,
  },
});
